export const S3KeyGenerator = {
  memberProfileImageKey: (businessId: number, memberId: number, extension: string) =>
    `uploads/business/${businessId}/members/${memberId}/profile.${extension}`,

//   memberDocumentKey: (businessId: number, memberId: number, documentId: number, extension: string) =>
//     `uploads/business/${businessId}/members/${memberId}/documents/${documentId}.${extension}`,

//   staffProfileImageKey: (businessId: number, staffId: number, extension: string) =>
//     `uploads/business/${businessId}/staff/${staffId}/profile.${extension}`,

//   businessPaymentReceiptKey: (businessId: number, memberId: number, paymentId: number, extension: string) =>
//     `uploads/business/${businessId}/payments/${memberId}/${paymentId}.${extension}`,
};
